module.exports = __webpack_public_path__ + "img/crustaceo.27788cd9.png";